<template>
  <div class="action-menu" ref="menu">
    <base-button size="sm" @click="isOpen = !isOpen">
      <slot name="trigger">⋮</slot>
    </base-button>
    <div class="action-menu__dropdown" v-if="isOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ActionMenu extends Vue {
  isOpen = false;

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(event: MouseEvent) {
    const menu = this.$refs.menu as HTMLElement;
    if (menu && !menu.contains(event.target as Node)) {
      this.isOpen = false;
    }
  }

  close() {
    this.isOpen = false;
  }
}
</script>

<style lang="scss" scoped>
.action-menu {
  position: relative;

  &__dropdown {
    position: absolute;
    right: 0;
    top: 100%;
    background: #111;
    border: 1px solid $color-theme-red;
    color: $color-theme-yellow;
    min-width: 200px;
    z-index: 10;
    margin-top: 6px;

    button {
      display: block;
      width: 100%;
      text-align: left;
      padding: 8px 12px;
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      font-size: 0.9rem;
      white-space: nowrap;

      &:hover {
        background: rgba($color-theme-red, 0.2);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>
